// ACC Review tab visibility — single source of truth.
//
// Matrix:
//   homeowner / board with is_acc_member = true   → visible
//   homeowner / board with is_acc_member = false  → hidden
//   management                                    → always visible
//   admin                                         → always visible
//
// Note: board membership alone is NOT enough — board members only see
// ACC Review when they sit on the Architectural Control Committee.
export function canSeeACCReview(profile) {
  const role = profile?.portalRole || profile?.role;
  return (
    Boolean(profile?.is_acc_member) ||
    role === 'management' ||
    role === 'admin'
  );
}
